import PersonCard from '../../../../components/PersonCard/PersonCard';
import styles from './fußball.module.css';
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NewsCard from '../../../Startseite/NewsCarousel/NewsCard';
import { FussballWidget } from '../../../../components/FussballDeWidget/FussballDeWidget';
import NoNews from '../../../../components/Error/NoNews/NoNews';
import { loadAssignmentsByArea } from '../../../../../code/AssignmentPersons';
import FootballMatches from '../../../../components/FootballMatches/FootballMatches';
import TeamLinks from '../../../../components/TeamLinks/TeamLinks';
function FußballPage() {
    const [persons, setPersons] = useState([]);
    const [articles, setArticles] = useState([]);
    const color = '--color-red';
    const colorText = '--main-color-white'
    useEffect(() => {
        loadAssignmentsByArea(8, setPersons, color, colorText);
    }, []);
    const navigate = useNavigate();
    useEffect(() => {
        fetch(`/api/news/last_news/Fußball?limit=3&includeSub=true`)
            .then(res => {
                if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}${res}`);
                return res.json();
            })
            .then(data => {
                setArticles(data);
            })
            .catch(err => {
                console.error("Fetch error:", err);

            });
    }, []);
    const task = [
        "Passwesen",
        "Spielverlegungen",
        "Platzbelegungen",
        "Verwaltung",
        "Inventar & Bestellung",
        "Administration DFBnet"
    ]
    return (
        <section className={styles.container}>
            <h1>Fußball</h1>
            <section>
                <h2 id='ansprechpartner'>Ansprechpartner</h2>
                <div className={styles.persons}>
                    {persons.map((person) => (<PersonCard person={person}></PersonCard>))}
                </div>
                <div className={styles.tasks}>
                    <p>Die <span>Geschäftstelle Fußball</span> übernimmt folgende Aufgaben:</p>
                    <ul className={styles.list}>{task.map((item) => (<li>{item}</li>))}</ul>
                </div>
            </section>
            <section id='letzte-news' className={styles.newsInfo}>
                <h2>Letzten News</h2>
                <div className={styles.news}>
                    {articles.length > 0 ? (
                        articles.map((item, index) => (
                            <NewsCard key={index} data={item} />
                        ))
                    ) : (
                        <NoNews layout='horizontal' />
                    )}
                </div>
                <div className={styles.spanInfo}>
                    <span tabIndex={0} onClick={() => navigate("/news")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {

                                e.preventDefault(); // Prevent space from scrolling
                                navigate("/news")
                            }
                        }}
                    >Weitere News hier...</span>
                </div>
            </section>
            {/* <section id='letzen-ergebnisse'>
                <h2>Letzten Ergebnisse</h2>
                <FootballMatches />
            </section> */}
            <section id='talentwerk'>
                <h2>Talentwerk</h2>
                <div className={styles.talentwerk}>
                    <div className={styles.imgDiv}>
                        <img src='/images/mannschaftssport/fussball/talentwerk_klein.png' alt='Talentwerk: Icon'></img>
                    </div>
                    <div className={styles.textDiv}>
                        <p>Das Talentwerk besitzt eine besondere Stellung in unserer Jugendarbeit beim TuS.</p>
                        <p>Unter dem Deckmantel des Projektes: Bezirksliga 2024 wollen wir eine gezielte Leisungsschulung für unserer Spieler ermöglichen und damit den Erhofften, ambizionierten Aufstieg in die Bezirksliga schaffen.</p>
                        <p>Alle Informationen findest du zum Talentwerk <span tabIndex={0} onClick={() => { navigate("/mannschaftssport/fußball/infos-zum-talentwerk") }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {

                                    e.preventDefault(); // Prevent space from scrolling
                                    navigate("/mannschaftssport/fußball/infos-zum-talentwerk")
                                }
                            }}
                        >hier</span>.</p>
                    </div>
                </div>
            </section>
            <TeamLinks />
            <section id='matchkalender'>
                <h2>Matchkalender</h2>
                <div>
                    <FussballWidget isMatchPlan={true} />
                </div>
            </section>

        </section>
    );
}
export default FußballPage;